export function contextForRequest(request, authId) {
  if (!request || !request.id || !request.apiToken) return null;
  return { requestId: request.id, token: request.apiToken, authId: authId || null };
}

export function firstBatchContext(list, authId) {
  return contextForRequest(Array.isArray(list) ? list[0] : null, authId);
}

export function activeContext(list, id, authId) {
  return contextForRequest(Array.isArray(list) ? list.find(item => String(item.id) === String(id)) : null, authId);
}

export function routeContext(route, batch, previous) {
  const name = String(route.name || '').replace(/^custom-/, '');
  const params = route.params || {};
  const query = route.query || {};
  const authId = query.authId || query.auth_id || null;
  if (name === 'general') return contextForRequest({ id: params.id, apiToken: query.token }, authId);
  if (name === 'document-list' || name === 'multiple-pdf' || name === 'multiple-document-list-review') return firstBatchContext(batch, authId);
  if (params.id && ['show-document', 'multiple-show-document', 'forms', 'attachments', 'multiple-forms', 'multiple-attachments'].includes(name)) {
    if (Array.isArray(batch) && batch.length) return activeContext(batch, params.id, authId);
    if (query.token) return contextForRequest({ id: params.id, apiToken: query.token }, authId);
    return previous && String(previous.requestId) === String(params.id) ? previous : null;
  }
  if (name.startsWith('multiple-') && params.id) return activeContext(batch, params.id, authId);
  if (['login', 'certlogin', 'my-signatures'].includes(name)) return null;
  if (previous && query.token && query.token !== previous.token) return null;
  if (previous && authId && query.token === previous.token) return { ...previous, authId };
  return previous || null;
}

export function latestOnly(apply) {
  let generation = 0;
  return async promise => {
    const current = ++generation;
    try {
      const value = await promise;
      if (current === generation) apply(value);
    } catch (error) {
      if (current === generation) throw error;
    }
  };
}
